import { Modal } from 'antd'
import CustomButton from 'components/atoms/custom-button'
import { xenditBankList } from 'constant'
import { BsCreditCard2Front } from 'react-icons/bs'
import { useQuery } from 'react-query'
import { getCcFee } from 'api'

const CREDIT_CARD_OPTION = { value: 'CREDIT_CARD', label: 'Kartu Kredit / Debit' }

const XenditBanksModal = ({
  open,
  selectedBank,
  handleNext,
  handleSelectedBank,
  onClose,
  onSelectCreditCard,
  isCreditCardLoading = false,
  isSubmitLoading = false
}) => {
  // Persentase biaya penanganan kartu kredit diambil dari app setting
  const { data: ccFeeResponse } = useQuery({
    queryKey: ['getCcFee'],
    queryFn: () => getCcFee(),
    enabled: open,
    onError: () => {}
  })
  // value dikirim sebagai string float, mis. "0", "3", "2.5"
  const ccFeeValue = Number(ccFeeResponse?.data?.value)
  const isCcFeeShown = Number.isFinite(ccFeeValue) && ccFeeValue > 0
  const ccFeePercentage = isCcFeeShown ? ccFeeValue.toLocaleString('id-ID') : ''

  return (
    <Modal
      className="lg:w-[552px] w-full "
      open={open}
      title={<h2 className="text-primary text-2xl font-normal">Pilih Metode Pembayaran</h2>}
      footer=""
      centered
      closable={false}
      maskClosable={false}>
      <div className="space-y-6">
        {/* Credit Card Option */}
        <div className="space-y-4">
          <p className="text-primary font-medium">Kartu Kredit / Debit</p>
          <div className={`py-3 border border-solid rounded-lg px-4 w-full border-lighter transition-colors ${isCreditCardLoading ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:border-brand-default'}`}>
            <div
               className={`flex justify-between w-full border-lighter transition-colors ${isCreditCardLoading ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
               onClick={isCreditCardLoading ? undefined : onSelectCreditCard}>
               <div className="flex gap-4 items-center">
                  <BsCreditCard2Front size={24} className="text-primary shrink-0" />
                  <span className="text-primary font-medium">{CREDIT_CARD_OPTION.label}</span>
               </div>
               <div className="flex items-center gap-1">
                  {isCreditCardLoading
                     ? <span className="text-xs text-secondary">Memproses...</span>
                     : <span className="text-xs text-secondary">Visa, Mastercard, JCB</span>
                  }
               </div>
            </div>
            {isCcFeeShown ? (
              <span className="text-xs text-disabled">
                Dikenakan biaya penanganan {ccFeePercentage}% dari total pembayaran.
              </span>
            ) : null}
          </div>
        </div>

        <div className="border border-lighter border-dashed" />

        {/* Virtual Account */}
        <div className="space-y-4">
          <p className="text-primary font-medium">Transfer Virtual Account</p>
          <div className="h-[240px] hidden-scrollbar flex flex-col overflow-y-auto gap-2">
            {xenditBankList.map((item, index) => (
              <div
                key={`bank-${index + 1}`}
                className={`py-3 border-b border-x-0 border-t-0 border-solid cursor-pointer border-lighter flex justify-between w-full`}
                onClick={() => handleSelectedBank(item)}>
                <div className="flex gap-4 item-center">
                  <div className="w-[56px] h-[24px] shrink-0 grow-0">
                    <img
                      src={item.image}
                      alt={`bank-${index + 1}`}
                      className="object-contain h-full w-full"
                    />
                  </div>
                  <span className="text-primary font-medium">{item.label}</span>
                </div>
                <div
                  className={`h-5 w-5 rounded-full border border-solid ${
                    selectedBank?.value === item.value ? 'border-brand-default' : 'border-lighter'
                  } shrink-0 grow-0 flex items-center justify-center`}>
                  <div
                    className={`h-2 w-2 shrink-0 grow-0 rounded-full ${
                      selectedBank?.value === item.value ? 'bg-brand-default' : 'bg-transparent'
                    }`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex gap-4 justify-end">
          <CustomButton disabled={isSubmitLoading} type="plain" onClick={onClose}>
            Batal
          </CustomButton>
          <CustomButton onClick={handleNext} isLoading={isSubmitLoading} disabled={!selectedBank}>
            Pilih
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default XenditBanksModal
